import * as Api from "../api/transfer.js";

export const agentRequestTransfer = async (token, cryptoCurrency, network, agent, amount, currency, maxSet, callback) => {
	try {
		const { data } = await Api.agentRequestTransfer(token, cryptoCurrency, network, agent, amount, currency, maxSet);
		callback(data);
	} catch (error) {
		console.log("agentRequestTransfer error", error);
	}
};

export const getTransfers = async (token, id, callback) => {
	try {
		const { data } = await Api.getTransfers(token, id);
		callback(data);
	} catch (error) {
		console.log("getTransfers error", error);
	}
};
